export const SESSIONS_STORAGE_KEY_MA_FILTERS_YEARS = 'MA_FILTERS_YEARS';
export const SESSIONS_STORAGE_KEY_MA_FILTERS_COUNTRIES = 'MA_FILTERS_COUNTRIES';
export const SESSIONS_STORAGE_KEY_MA_FILTERS_TYPES = 'MA_FILTERS_TYPES';
export const SESSIONS_STORAGE_KEY_MA_FILTERS_COMPANY_SELLERS = 'MA_FILTERS_COMPANIES_SELLER';
export const SESSIONS_STORAGE_KEY_MA_FILTERS_COMPANY_BUYERS = 'MA_FILTERS_COMPANIES_BUYER';
export const SESSIONS_STORAGE_KEY_MA_FILTERS_ASSETS = 'MA_FILTERS_ASSETS';
